import { cardImageSources, type GenericCharacter } from './types'

export const genericDragona: GenericCharacter = {
  id: 'generic-dragona',
  enabled: true,
  order: 5,
  displayName: 'Chispa',
  icon: '🐉',
  imageSources: cardImageSources('generic-dragona'),
}
